import { render } from "./IoFooter.vue?vue&type=template&id=bc3b3040&ts=true"
import script from "./IoFooter.vue?vue&type=script&lang=ts"
export * from "./IoFooter.vue?vue&type=script&lang=ts"

import "./IoFooter.vue?vue&type=style&index=0&id=bc3b3040&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__